import { render, staticRenderFns } from "./DeleteGeofenceModal.vue?vue&type=template&id=3b6afbc4"
import script from "./DeleteGeofenceModal.vue?vue&type=script&lang=js"
export * from "./DeleteGeofenceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports